import * as React from "react";
import { cx } from "../internal/cx.js";

/**
 * Mounts the Cakewalk v2 visual theme on every descendant by setting
 * `class="cw-v2-theme cw-v2-theme-root"` and `data-cw-v2-theme="light"`.
 *
 * Every page that renders v2 components from `@cakewalk/ui` must wrap
 * its tree in a `<ThemeRoot>` (typically at the app's composition root,
 * once, around `<App />`). Without it, the lifted `cw-v2-*` utility
 * classes in `components.css` resolve their CSS custom properties to
 * `unset` and components render unstyled.
 *
 * The component is intentionally minimal — no theme switching API yet.
 * When dark mode lands, the `data-cw-v2-theme` attribute is the swap
 * point.
 */
export interface ThemeRootProps extends React.HTMLAttributes<HTMLDivElement> {}

export const ThemeRoot = React.forwardRef<HTMLDivElement, ThemeRootProps>(function ThemeRoot(
  { className, children, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cx("cw-v2-theme cw-v2-theme-root", className)}
      data-cw-v2-theme="light"
      {...props}
    >
      {children}
    </div>
  );
});

ThemeRoot.displayName = "ThemeRoot";
